import React from 'react'
import { Booking } from './types'
import { buildContent } from './utils'
import UpcomingTripExperiment from './UpcomingTripExperiment'

export default function CrossSell({ booking }: { booking: Booking }) {
  const { xSellUrl, xSellTargetId } = buildContent(booking)

  return (
    <UpcomingTripExperiment
      booking={booking}
      xSellUrl={xSellUrl}
      xSellTargetId={xSellTargetId}
    />
  )
}
